import React from "react";
import SoftBox from "components/SoftBox";
import { useSelector } from "react-redux";

const ApnaSelect = ({
  options = [],
  name,
  value,
  onChange,
  onBlur,
  required = false,
  disabled = false,
  placeholder = "Choose",
  origin = "Option",
  error = false,
  className,
  multiSelect = false,
}) => {
  const userTheme = useSelector((state) => state.commonSlice.theme);
  const handleChange = (e) => {
    console.log("asdfasdf",e,e.target.value)
    
    const selectedValue = multiSelect
      ? Array.from(e.target.selectedOptions, (option) => option.value)
      : e.target.value;
    onChange?.({
      target: {
        name,
        value: selectedValue,
      },
    });
  };

  return (
    <SoftBox>
      <select
        required={required}
        name={name}
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
        disabled={disabled}
        multiple={multiSelect}
        className={`${className} `}
        style={{
          padding: "10px",
          width: "100%",
          borderRadius: "5px",
          border: error ? ".4px solid #fd5c70" : ".4px solid #456",
          background: userTheme=='dark' ? '#404040 ' : "#fff",
          color: userTheme=='dark' ? '#fff' : '#495057 ',
          minHeight: multiSelect ? "100px" : "auto",
        }}
      >
        {!multiSelect && (
          <option value="">{placeholder || `Choose ${origin}`}</option>
        )}
        {options?.map((elm, i) => (
          <option key={elm?._id || elm?.name || i} value={elm?._id || elm?.name}
           style={{background:userTheme=='dark' ? '#404040 ' :'#FFF',color:userTheme=='dark' ? '#495057' : '#000'}}>
            {elm?.name}
          </option>
        ))}
      </select>
    </SoftBox>
  );
};

export default ApnaSelect;
